// extracted by mini-css-extract-plugin
export default {"container":"vRMER","small":"E0q+F","triangle":"_2QS-y","top":"E8Kws"};